import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { api } from '@/lib/api'
import { toast } from 'sonner'

export function useKlaviyoStatus() {
  return useQuery({
    queryKey: ['klaviyo-status'],
    queryFn: async () => {
      return api.settings.getKlaviyoStatus()
    },
  })
}

export function useSaveKlaviyoApiKey() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (apiKey: string) => {
      return api.settings.saveKlaviyoApiKey(apiKey)
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['klaviyo-status'] })
      toast.success('Klaviyo configurado com sucesso!')
    },
    onError: (error: Error) => {
      toast.error(error.message || 'Erro ao configurar Klaviyo')
    },
  })
}

export function useTestKlaviyoConnection() {
  return useMutation({
    mutationFn: async () => {
      return api.settings.testKlaviyoConnection()
    },
    onSuccess: (data) => {
      if (data.success) {
        toast.success('Conexão com Klaviyo OK!')
      } else {
        toast.error(data.error || 'Falha na conexão')
      }
    },
    onError: (error: Error) => {
      toast.error(error.message || 'Erro ao testar conexão')
    },
  })
}

export function useRemoveKlaviyo() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async () => {
      return api.settings.removeKlaviyo()
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['klaviyo-status'] })
      toast.success('Integração Klaviyo removida')
    },
    onError: (error: Error) => {
      toast.error(error.message || 'Erro ao remover integração')
    },
  })
}
